import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Drawer,
  Avatar,
  InputAdornment,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MailIcon from "../../assets/mail 1.png"
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { constructNow } from "date-fns";
import { IMAGE_BASE_URL } from "../../config";

export default function EmailBottomSheet({ open, onClose,index, digitalLineItemClaimId,digitalorderData}) {
  console.log("index---",index)
  const navigate = useNavigate();
  
      const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");
const [requestId, setRequestId] = useState(null);
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(30);
    const { makeApiRequest } = useApiRequest();
const [emailError, setEmailError] = useState("");
  const emailRef = useRef(null);
  const otpRefs = useRef([]);
  const params = new URLSearchParams(window.location.search);
const orderID = params.get("value");

console.log("Value:", orderID); // 855B4CCE282A4CFD
const validateEmail = (value) => {
  const regex = /^(?!.*\.\.)(?!.*\.$)(?!\.)([a-zA-Z0-9]([a-zA-Z0-9._%+\-]*[a-zA-Z0-9])?)@([a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  return regex.test(value);
};
  // ✅ Auto focus
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (step === 1) emailRef.current?.focus();
        if (step === 2) otpRefs.current[0]?.focus();
      }, 300);
    }
  }, [open, step]);

  // ✅ Timer
  useEffect(() => {
    if (step === 2 && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [step, timer]);


const sendOtp = () => {
  if (!email) {
    setEmailError("Email is required");
    return;
  }

  if (!validateEmail(email)) {
    setEmailError("Enter valid email");
    return;
  }

  setEmailError("");

  makeApiRequest({
    url: "https://api-prod.daalchini.co.in/consumerbe/api/v1/digital/claim/email-verify",
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId || "",
    },
    data: {
      email: email,
    },
    handleSuccess: (res) => {
      console.log("OTP Sent:", res?.data?.data.requestId);

      setRequestId(res?.data?.data.requestId);
      setStep(2);
      setTimer(30);
    },
    handleError: (err) => {
      console.log("Error:", err);
      setEmailError("Failed to send OTP");
    },
  });
};

  // ✅ Verify OTP
const verifyOtp = () => {
  const code = otp.join("");

  makeApiRequest({
    url: "https://api-prod.daalchini.co.in/consumerbe/api/v1/digital/claim/email-verify/code",
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId || "",
    },
    data: {
     "requestId":requestId, // This should ideally come from the response of sendOtp API
      otp: parseInt(code)  ,
    },
    handleSuccess: (res) => {
      console.log("Verified:", res);
      //alert("Verified ✅");
      resetState();
      onClose();
      Claim(digitalLineItemClaimId)
     
    },
    handleError: (err) => {
      console.log("Error:", err.response.data.status.message);
       toast.error(`${err.response.data.status.message}`);
      //alert("Invalid OTP ❌");
      
    },
  });
};


const Claim= (digitalLineItemClaimId) => {
  const code = otp.join("");

  makeApiRequest({
    url: "https://api-prod.daalchini.co.in/consumerbe/api/v1/digital/claim",
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId || "",
    },
    data: {
    
	"digitalLineItemId":digitalLineItemClaimId,
  "emailId":email
    },
    handleSuccess: (res) => {
      console.log("Verified:", res);
      //alert("Verified ✅");
      resetState();
      onClose();

      navigate(`/digital_details?digitalLineItemClaimId=${digitalLineItemClaimId}&orderId=${orderID}`);
    },
    handleError: (err) => {
      console.log("Error:", err);
       toast.error("Invalid OTP ❌");
      //alert("Invalid OTP ❌");
      
    },
  });
};




  const resetState = () => {
    setStep(1);
    setEmail("");
    setOtp(["", "", "", ""]);
    setTimer(30);
  };

  // ✅ OTP Change (ALPHANUMERIC)
  const handleOtpChange = (value, index) => {
    if (!/^[a-zA-Z0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.toUpperCase();
    setOtp(newOtp);

    if (value && index < 3) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  // ✅ Backspace focus fix
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        otpRefs.current[index - 1]?.focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  // ✅ Paste OTP
  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text").slice(0, 4);
    if (!/^[a-zA-Z0-9]+$/.test(paste)) return;

    const newOtp = paste.toUpperCase().split("");
    setOtp(newOtp);

    otpRefs.current[3]?.focus();
  };

const onChangeEmail = () => {
  setStep(1);
  setOtp(["", "", "", ""]); 
  setEmail("");
}



  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={() => {
        resetState();
        onClose();
      }}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          height: "70vh",
          //position: "relative",
          overflow: "visible",
        },
      }}
    >
      {/* Floating Icon */}
      <Box
        sx={{
          position: "absolute",
          top: -40,
          left: "50%",
          transform: "translateX(-50%)",
          bgcolor: "#fff",
          borderRadius: "50%",
          p: 1,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
         <img src={MailIcon} alt="Mail" style={{width:"72px"}}/>
      </Box>

      <Box
        sx={{
          p: 3,
          pt: 6,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {/* Title */}
  {/*       <Typography align="center" fontWeight={600} mb={2}>
          {step === 1
            ? "You Are Using @ To Claim"
            : "Enter Verification Code"}
        </Typography> */}

        {/* Card */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 2,
            borderRadius: 3,
            border: "1px solid #eee",
            mb: 3,
          }}
        >
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: 2,
              border: "1px solid #eee",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              color: "red",
              mr: 2,
            }}
          >
          <img
              src={`${IMAGE_BASE_URL}/${digitalorderData?.[index]?.imageUrl} `}
              alt={digitalorderData?.[index]?.itemName}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/48?text=Logo";
              }}
            />

       </Box>

          <Box>
            <Typography fontWeight={600}>
              {digitalorderData?.[index]?.itemName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
             {digitalorderData?.[index]?.itemDescription?.length > 40
                  ? digitalorderData?.[index]?.itemDescription.slice(0, 40) + "..."
                  : digitalorderData?.[index]?.itemDescription}
            </Typography>
          </Box>
        </Box>

        {/* STEP 1 */}
        
        {step === 1 && (
          <>
            <Typography sx={{ fontSize: 14, mb: 1 }}>
              Enter Email
            </Typography>

      <TextField
  fullWidth
  placeholder="name@example.com"
  value={email}
  inputRef={emailRef}
  onChange={(e) => {
    setEmail(e.target.value);
    setEmailError(""); // clear error on typing
  }}
  error={!!emailError}
  helperText={emailError}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <MailOutlineIcon sx={{ color: "#9ca3af" }} />
      </InputAdornment>
    ),
  }}
  sx={{
    mb: 3,
    "& .MuiOutlinedInput-root": {
      borderRadius: 3,
      bgcolor: "#f9fafb",
    },
  }}
/>
          </>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <>
          <Box style={{display:"flex",justifyContent:"center"}}>
            <Typography variant="body2" mb={2}>
            Enter The 4-Digit Code Sent To Your E-Mail.
            </Typography>
            </Box>
            <Box display="flex" justifyContent="center" mb={2}>
            <Box display="flex" justifyContent="space-between" mb={2} width={"274px"}>
              {otp.map((digit, index) => (
                <TextField
                  key={index}
                  value={digit}
                  inputRef={(el) => (otpRefs.current[index] = el)}
                  onChange={(e) =>
                    handleOtpChange(e.target.value, index)
                  }
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  onPaste={handlePaste}
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: "center",
                      fontSize: 20,
                      textTransform: "uppercase",
                    },
                  }}
                  sx={{
                    width: 60,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              ))}
            </Box>
            </Box>


            {/* Resend */}
            <Box style={{display:"flex",justifyContent: "center"}}>
            <Typography variant="body2" color="#6b7280">
              Didn’t receive code?{" "}
              {timer > 0 ? (
                `Resend in ${timer}s`
              ) : (
                <span
                  style={{
                    color: "#00A86B",
                    cursor: "pointer",
                    fontWeight: 500,
                  }}
                  onClick={sendOtp}
                >
                  Resend
                </span>
              )}
            </Typography>

            </Box>
            <Box style={{display:"flex",justifyContent: "center"}}>
                              <Typography
        variant="body2"
        onClick={onChangeEmail}
        sx={{
          mb: 4,
          color: "#3B82F6",
          cursor: "pointer",
          textDecoration: "underline",
          fontWeight: 500,mt:2
        }}
      >
        Tap here to change your Email
      </Typography>
      </Box>

          </>
        )}

        <Box sx={{ flexGrow: 1 }} />

        {/* BUTTON */}
        <Button
          fullWidth
          variant="contained"
        disabled={
  step === 1 ? !email || !validateEmail(email) : otp.includes("")
}
          onClick={step === 1 ? sendOtp : verifyOtp}
          style={{background:"#00A86B"}}
          sx={{
            borderRadius: 3,
            py: 1.5,
            bgcolor:
              step === 1
                ? email
                  ? "#00A86B"
                  : "#d1d5db"
                : "#00A86B",
            textTransform: "none",
            fontWeight: 600,
            ":hover": {
            /*   bgcolor:
                step === 1    ? email
                  ? "#00A86B"
                  : "#d1d5db"
                : "#00A86B", */
            },    

          }}
        >
          {step === 1 ? "Send OTP" : "Verify"}
        </Button>
      </Box>
    </Drawer>
  );
}